module.exports = __webpack_public_path__ + "static/media/logout.be5e4d78.svg";